<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg6354"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs6358"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath6368"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path6366" /></clipPath></defs><g
     id="g6360"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g6362"><g
         id="g6364"
         clip-path="url(#clipPath6368)"><g
           id="g6370"
           transform="translate(484.9414,270.6201)"><path
             d="m 0,0 -0.1,0.109 -38.241,38.67"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6372" /></g><g
           id="g6374"
           transform="translate(67.3203,312.1611)"><path
             d="M 0,0 -40.262,-41.541"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6376" /></g><g
           id="g6378"
           transform="translate(67.3203,251.6104)"><path
             d="m 0,0 v 60.551 164.135 c 0,15.577 12.626,28.204 28.205,28.204 h 158.184 164.687 c 15.578,0 28.204,-12.627 28.204,-28.204 V 57.789 1.11"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6380" /></g><g
           id="g6382"
           transform="translate(208.9414,215.499)"><path
             d="M 0,0 H 96.044"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6384" /></g><g
           id="g6386"
           transform="translate(222.5957,330.0664)"><path
             d="M 0,0 H -22.886 V -56.464"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6388" /></g><g
           id="g6390"
           transform="translate(199.71,302.3691)"><path
             d="M 0,0 H 21.067"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6392" /></g><g
           id="g6394"
           transform="translate(280.8848,330.0664)"><path
             d="M 0,0 H -22.886 V -56.464"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6396" /></g><g
           id="g6398"
           transform="translate(257.999,302.3691)"><path
             d="M 0,0 H 21.067"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6400" /></g><g
           id="g6402"
           transform="translate(335.8389,330.5498)"><path
             d="M 0,0 H -23.749 V -56.361 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6404" /></g><g
           id="g6406"
           transform="translate(334.0879,302.3691)"><path
             d="M 0,0 H -21.998"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6408" /></g><g
           id="g6410"
           transform="translate(380.208,301.0771)"><path
             d="M 0,0 23.894,-27.148"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6412" /></g><g
           id="g6414"
           transform="translate(373.3486,330.8096)"><path
             d="M 0,0 V -56.881"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6416" /></g><g
           id="g6418"
           transform="translate(404.1016,316.0273)"><path
             d="m 0,0 c 0,-8.164 -7.158,-14.783 -15.619,-14.783 -4.196,0 -15.011,-0.066 -15.011,-0.066 0,0 -0.067,10.734 -0.067,14.849 0,3.38 -0.037,14.782 -0.037,14.782 h 15.115 C -7.158,14.782 0,8.164 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6420" /></g><g
           id="g6422"
           transform="translate(164.7803,301.835)"><path
             d="m 0,0 c 0,-15.708 -12.733,-28.44 -28.441,-28.44 -15.707,0 -28.441,12.732 -28.441,28.44 0,15.707 12.734,28.44 28.441,28.44 C -12.733,28.44 0,15.707 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6424" /></g><g
           id="g6426"
           transform="translate(425.7607,240.5947)"><path
             d="m 0,0 52.778,30.72 c 3.628,2.111 8.18,-0.506 8.18,-4.703 V -204.21 c 0,-15.952 -12.933,-28.885 -28.886,-28.885 h -403.666 c -15.953,0 -28.885,12.933 -28.885,28.885 V 25.91 c 0,4.244 4.602,6.891 8.271,4.756 L -174.516,-96.04 c 2.94,-1.711 6.571,-1.711 9.51,0 l 138.483,80.602"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6428" /></g><g
           id="g6430"
           transform="translate(274.3887,443.4814)"><path
             d="m 0,0 h -34.851 v 15.507 c 0,5.598 4.539,10.138 10.138,10.138 h 14.575 C -4.539,25.645 0,21.105 0,15.507 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6432" /></g><g
           id="g6434"
           transform="translate(300.5273,369.0127)"><path
             d="m 0,0 h -87.128 c -4.851,0 -8.783,3.933 -8.783,8.783 v 56.903 c 0,4.851 3.932,8.783 8.783,8.783 H 0 c 4.851,0 8.783,-3.932 8.783,-8.783 V 8.783 C 8.783,3.933 4.851,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6436" /></g><g
           id="g6438"
           transform="translate(416.2949,48.4893)"><path
             d="M 0,0 -179.607,104.539"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path6440" /></g></g></g></g></svg>
</template>
